import React, { createContext, useCallback, useContext } from 'react';
import { I18nManager, I18nContext, useI18n } from '@shopify/react-i18n';

// Create a context for currencyFormatter with the updated type
var CurrencyFormatterContext = createContext(undefined);
// Provide a default locale
var DEFAULT_LOCALE = 'en';
// Create a component that includes both I18nContext.Provider and CurrencyFormatterContext.Provider
var CurrencyFormatterProvider = function (_a) {
    var children = _a.children, _b = _a.locale, locale = _b === void 0 ? DEFAULT_LOCALE : _b;
    // Initialize I18nManager with the locale
    var i18nManager = new I18nManager({
        locale: locale,
        onError: function (error) {
            console.error('I18n Error:', error);
        },
    });
    // Render I18nContext.Provider and CurrencyFormatterContext.Provider
    return (React.createElement(I18nContext.Provider, { value: i18nManager },
        React.createElement(InternalCurrencyFormatterProvider, null, children)));
};
// Internal provider to access useI18n properly
var InternalCurrencyFormatterProvider = function (_a) {
    var children = _a.children;
    var i18n = useI18n()[0];
    // Define the currencyFormatter function with useCallback
    var currencyFormatter = useCallback(function (amount, currency, options) {
        if (options === void 0) { options = {}; }
        var _a = options.format, format = _a === void 0 ? 'short' : _a, _b = options.excludeSymbol, excludeSymbol = _b === void 0 ? false : _b;
        var formatOption = excludeSymbol ? 'none' : format;
        return i18n.formatCurrency(amount, { currency: currency, form: formatOption });
    }, [i18n]);
    // Define the getCurrencySymbol function with useCallback
    var getCurrencySymbol = useCallback(function (currency) {
        try {
            // Get the currency symbol using i18n
            var symbol = i18n.getCurrencySymbol(currency).symbol;
            return symbol;
        }
        catch (_a) {
            return undefined;
        }
    }, [i18n]);
    // Create the context value object
    var contextValue = {
        currencyFormatter: currencyFormatter,
        getCurrencySymbol: getCurrencySymbol
    };
    return (React.createElement(CurrencyFormatterContext.Provider, { value: contextValue }, children));
};
// Custom hook to use the CurrencyFormatterContext
var useCurrencyFormatter = function () {
    var context = useContext(CurrencyFormatterContext);
    if (context === undefined) {
        throw new Error('useCurrencyFormatter must be used within a CurrencyFormatterProvider');
    }
    return context;
};

export { CurrencyFormatterProvider, useCurrencyFormatter };
//# sourceMappingURL=CurrencyFormatterContext.js.map
